export default __webpack_public_path__ + "static/media/prize-3-bm.ea0cba03.webp";